import React from 'react'

export default function ContentBoxValores(props) {
    return (
        <>
            <div className="col-lg-12 col-md-12 col-sm-12" id={props.titulo} style={{ marginTop: '50px' }} >
                <div className="card">
                    <div className="header">
                        <h2> <i className='zmdi zmdi-dot-circle-alt' style={{ color: props.color }} ></i> {props.titulo} <small style={{ textTransform: 'uppercase' }}> {props.subtitulo} </small> </h2>
                    </div>
                    <div className="body">
                        {props.children}
                    </div>
                </div>
            </div>
        </>
    )
}